"use client";

import { c as _c } from "react/compiler-runtime";
import { use } from "react";
import { motion, type Variants } from "framer-motion";
import { CheckCircle2, Shield, Lock, Eye, FileText, Search, Sparkles, FolderOpen, ArrowRight, Users, Building, Calendar, BarChart3, Megaphone } from "lucide-react";
import Link from "next/link";
import { Button } from "~/components/ui/button";
import { Badge } from "~/components/ui/badge";
import { useTranslations } from "next-intl";
import { isPricingEnabledClient } from "~/lib/pricing";
export default function FeaturesPage(t0) {
  const $ = _c(552);
  const {
    params
  } = t0;
  use(params);
  const t = useTranslations("featuresPage");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 40
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hidden: t1,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: "easeOut"
        }
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fadeInUp = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t("hero.badge");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Badge variant="outline" className="mb-6 rounded-full border-teal-200 bg-teal-50 px-4 py-1.5 text-sm text-teal-700 dark:border-teal-900 dark:bg-teal-950/30 dark:text-teal-400">{t4}</Badge>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t.rich("hero.title", {
      br: _temp,
      gradient: _temp2
    });
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <h1 className="mb-6 text-4xl leading-tight font-bold tracking-tight text-gray-900 md:text-6xl dark:text-white">{t6}</h1>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("hero.description");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <p className="mx-auto max-w-2xl text-xl leading-relaxed text-gray-600 dark:text-gray-300">{t8}</p>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t5 || $[16] !== t7 || $[17] !== t9) {
    t10 = <section className="container mx-auto mb-32 px-4 text-center"><motion.div initial="hidden" whileInView="visible" viewport={t3} variants={fadeInUp} className="mx-auto max-w-4xl">{t5}{t7}{t9}</motion.div></section>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      once: true
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"><CheckCircle2 className="h-6 w-6" /></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("sections.tickets.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t13}</h2>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("sections.tickets.description");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t15}</p>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("sections.tickets.items.0");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t) {
    t18 = t("sections.tickets.items.1");
    $[31] = t;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t) {
    t19 = t("sections.tickets.items.2");
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t17 || $[36] !== t18 || $[37] !== t19) {
    t20 = <ul className="space-y-4">{[t17, t18, t19].map(_temp3)}</ul>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t14 || $[40] !== t16 || $[41] !== t20) {
    t21 = <motion.div initial="hidden" whileInView="visible" viewport={t11} variants={fadeInUp}>{t12}{t14}{t16}{t20}</motion.div>;
    $[39] = t14;
    $[40] = t16;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  let t23;
  let t24;
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      opacity: 0,
      x: 40
    };
    t23 = {
      opacity: 1,
      x: 0
    };
    t24 = {
      once: true
    };
    t25 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
    $[46] = t25;
  } else {
    t22 = $[43];
    t23 = $[44];
    t24 = $[45];
    t25 = $[46];
  }
  let t26;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-teal-500/10 blur-3xl" />;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="flex items-center justify-between border-b border-gray-100 bg-white p-4 dark:border-gray-800 dark:bg-gray-900"><div className="flex items-center gap-3"><div className="font-bold text-gray-900 dark:text-white">#T-124</div><div className="h-4 w-px bg-gray-200 dark:bg-gray-700" /><div className="text-sm font-medium text-gray-700 dark:text-gray-300">Fuite d'eau - Hall d'entrée</div></div></div>;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t) {
    t28 = t("sections.tickets.mockup.system_user");
    $[49] = t;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t28) {
    t29 = <span className="font-semibold text-gray-900 dark:text-gray-200">{t28}</span>;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t) {
    t30 = t("sections.tickets.mockup.system_message");
    $[53] = t;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== t29 || $[56] !== t30) {
    t31 = <div className="rounded-r-lg border-l-4 border-orange-500 bg-gray-100 p-3 text-sm text-gray-600 dark:bg-gray-900 dark:text-gray-400">{t29}{" "}{t30}</div>;
    $[55] = t29;
    $[56] = t30;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="h-8 w-8 shrink-0 rounded-full bg-gray-200 dark:bg-gray-700" />;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t) {
    t33 = t("sections.tickets.mockup.user_message");
    $[59] = t;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== t33) {
    t34 = <p>{t33}</p>;
    $[61] = t33;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="mt-2 flex h-20 w-32 items-center justify-center rounded-lg border border-gray-200 bg-gray-100 dark:border-gray-700 dark:bg-gray-900"><FileText className="h-4 w-4 text-gray-400" /></div>;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t34) {
    t36 = <div className="flex gap-3">{t32}<div className="max-w-[90%] rounded-2xl rounded-tl-none border border-gray-100 bg-white p-3 text-sm text-gray-600 shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">{t34}{t35}</div></div>;
    $[64] = t34;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t31 || $[67] !== t36) {
    t37 = <div className="flex flex-1 flex-col gap-4 overflow-y-auto bg-gray-50 p-6 dark:bg-gray-950/50">{t31}{t36}</div>;
    $[66] = t31;
    $[67] = t36;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] !== t) {
    t38 = t("sections.tickets.mockup.sidebar_title");
    $[69] = t;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t38) {
    t39 = <div className="mb-3 text-xs font-semibold tracking-wider text-gray-500 uppercase dark:text-gray-400">{t38}</div>;
    $[71] = t38;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t) {
    t40 = t("sections.tickets.mockup.status_label");
    $[73] = t;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] !== t40) {
    t41 = <div className="mb-1 text-xs text-gray-500">{t40}</div>;
    $[75] = t40;
    $[76] = t41;
  } else {
    t41 = $[76];
  }
  let t42;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="h-1.5 w-1.5 rounded-full bg-amber-500" />;
    $[77] = t42;
  } else {
    t42 = $[77];
  }
  let t43;
  if ($[78] !== t) {
    t43 = t("sections.tickets.mockup.status_value");
    $[78] = t;
    $[79] = t43;
  } else {
    t43 = $[79];
  }
  let t44;
  if ($[80] !== t43) {
    t44 = <div className="inline-flex items-center gap-2 rounded-md border border-amber-100 bg-amber-50 px-2.5 py-1 text-sm font-medium text-amber-700 dark:border-amber-900/30 dark:bg-amber-900/20 dark:text-amber-400">{t42}{t43}</div>;
    $[80] = t43;
    $[81] = t44;
  } else {
    t44 = $[81];
  }
  let t45;
  if ($[82] !== t41 || $[83] !== t44) {
    t45 = <div>{t41}{t44}</div>;
    $[82] = t41;
    $[83] = t44;
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== t) {
    t46 = t("sections.tickets.mockup.priority_label");
    $[85] = t;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== t46) {
    t47 = <div className="mb-1 text-xs text-gray-500">{t46}</div>;
    $[87] = t46;
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== t) {
    t48 = t("sections.tickets.mockup.priority_value");
    $[89] = t;
    $[90] = t48;
  } else {
    t48 = $[90];
  }
  let t49;
  if ($[91] !== t48) {
    t49 = <div className="inline-flex items-center gap-2 rounded-md bg-gray-100 px-2.5 py-1 text-sm font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">{t48}</div>;
    $[91] = t48;
    $[92] = t49;
  } else {
    t49 = $[92];
  }
  let t50;
  if ($[93] !== t47 || $[94] !== t49) {
    t50 = <div>{t47}{t49}</div>;
    $[93] = t47;
    $[94] = t49;
    $[95] = t50;
  } else {
    t50 = $[95];
  }
  let t51;
  if ($[96] !== t) {
    t51 = t("sections.tickets.mockup.assigned_label");
    $[96] = t;
    $[97] = t51;
  } else {
    t51 = $[97];
  }
  let t52;
  if ($[98] !== t51) {
    t52 = <div className="mb-1 text-xs text-gray-500">{t51}</div>;
    $[98] = t51;
    $[99] = t52;
  } else {
    t52 = $[99];
  }
  let t53;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-[10px] font-bold text-blue-600 dark:bg-blue-900 dark:text-blue-400">SY</div>;
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  let t54;
  if ($[101] !== t) {
    t54 = t("sections.tickets.mockup.assigned_value");
    $[101] = t;
    $[102] = t54;
  } else {
    t54 = $[102];
  }
  let t55;
  if ($[103] !== t54) {
    t55 = <div className="flex items-center gap-2">{t53}<span className="text-sm text-gray-700 dark:text-gray-300">{t54}</span></div>;
    $[103] = t54;
    $[104] = t55;
  } else {
    t55 = $[104];
  }
  let t56;
  if ($[105] !== t52 || $[106] !== t55) {
    t56 = <div>{t52}{t55}</div>;
    $[105] = t52;
    $[106] = t55;
    $[107] = t56;
  } else {
    t56 = $[107];
  }
  let t57;
  if ($[108] !== t45 || $[109] !== t50 || $[110] !== t56) {
    t57 = <div className="space-y-4">{t45}{t50}{t56}</div>;
    $[108] = t45;
    $[109] = t50;
    $[110] = t56;
    $[111] = t57;
  } else {
    t57 = $[111];
  }
  let t58;
  if ($[112] !== t39 || $[113] !== t57) {
    t58 = <div className="w-1/3 space-y-6 border-l border-gray-100 bg-white p-4 dark:border-gray-800 dark:bg-gray-900"><div>{t39}{t57}</div></div>;
    $[112] = t39;
    $[113] = t57;
    $[114] = t58;
  } else {
    t58 = $[114];
  }
  let t59;
  if ($[115] !== t37 || $[116] !== t58) {
    t59 = <motion.div initial={t22} whileInView={t23} viewport={t24} transition={t25} className="relative">{t26}<div className="relative flex h-[400px] flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t27}<div className="flex flex-1 overflow-hidden">{t37}{t58}</div></div></motion.div>;
    $[115] = t37;
    $[116] = t58;
    $[117] = t59;
  } else {
    t59 = $[117];
  }
  let t60;
  if ($[118] !== t21 || $[119] !== t59) {
    t60 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t21}{t59}</div></section>;
    $[118] = t21;
    $[119] = t59;
    $[120] = t60;
  } else {
    t60 = $[120];
  }
  let t61;
  let t62;
  let t63;
  let t64;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = {
      opacity: 0,
      x: -40
    };
    t62 = {
      opacity: 1,
      x: 0
    };
    t63 = {
      once: true
    };
    t64 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[121] = t61;
    $[122] = t62;
    $[123] = t63;
    $[124] = t64;
  } else {
    t61 = $[121];
    t62 = $[122];
    t63 = $[123];
    t64 = $[124];
  }
  let t65;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-bl from-indigo-500/10 to-purple-500/10 blur-3xl" />;
    $[125] = t65;
  } else {
    t65 = $[125];
  }
  let t66;
  if ($[126] !== t) {
    t66 = t("sections.calendar.mockup.month");
    $[126] = t;
    $[127] = t66;
  } else {
    t66 = $[127];
  }
  let t67;
  if ($[128] !== t66) {
    t67 = <h3 className="text-lg font-bold text-gray-900 dark:text-white">{t66}</h3>;
    $[128] = t66;
    $[129] = t67;
  } else {
    t67 = $[129];
  }
  let t68;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 dark:border-gray-700"><ArrowRight className="h-4 w-4 rotate-180" /></div>;
    $[130] = t68;
  } else {
    t68 = $[130];
  }
  let t69;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <div className="flex gap-2">{t68}<div className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 dark:border-gray-700"><ArrowRight className="h-4 w-4" /></div></div>;
    $[131] = t69;
  } else {
    t69 = $[131];
  }
  let t70;
  if ($[132] !== t67) {
    t70 = <div className="mb-6 flex items-center justify-between">{t67}{t69}</div>;
    $[132] = t67;
    $[133] = t70;
  } else {
    t70 = $[133];
  }
  let t71;
  if ($[134] !== t) {
    t71 = t("sections.calendar.mockup.days.0");
    $[134] = t;
    $[135] = t71;
  } else {
    t71 = $[135];
  }
  let t72;
  if ($[136] !== t71) {
    t72 = <div>{t71}</div>;
    $[136] = t71;
    $[137] = t72;
  } else {
    t72 = $[137];
  }
  let t73;
  if ($[138] !== t) {
    t73 = t("sections.calendar.mockup.days.1");
    $[138] = t;
    $[139] = t73;
  } else {
    t73 = $[139];
  }
  let t74;
  if ($[140] !== t73) {
    t74 = <div>{t73}</div>;
    $[140] = t73;
    $[141] = t74;
  } else {
    t74 = $[141];
  }
  let t75;
  if ($[142] !== t) {
    t75 = t("sections.calendar.mockup.days.2");
    $[142] = t;
    $[143] = t75;
  } else {
    t75 = $[143];
  }
  let t76;
  if ($[144] !== t75) {
    t76 = <div>{t75}</div>;
    $[144] = t75;
    $[145] = t76;
  } else {
    t76 = $[145];
  }
  let t77;
  if ($[146] !== t) {
    t77 = t("sections.calendar.mockup.days.3");
    $[146] = t;
    $[147] = t77;
  } else {
    t77 = $[147];
  }
  let t78;
  if ($[148] !== t77) {
    t78 = <div>{t77}</div>;
    $[148] = t77;
    $[149] = t78;
  } else {
    t78 = $[149];
  }
  let t79;
  if ($[150] !== t) {
    t79 = t("sections.calendar.mockup.days.4");
    $[150] = t;
    $[151] = t79;
  } else {
    t79 = $[151];
  }
  let t80;
  if ($[152] !== t79) {
    t80 = <div>{t79}</div>;
    $[152] = t79;
    $[153] = t80;
  } else {
    t80 = $[153];
  }
  let t81;
  if ($[154] !== t) {
    t81 = t("sections.calendar.mockup.days.5");
    $[154] = t;
    $[155] = t81;
  } else {
    t81 = $[155];
  }
  let t82;
  if ($[156] !== t81) {
    t82 = <div>{t81}</div>;
    $[156] = t81;
    $[157] = t82;
  } else {
    t82 = $[157];
  }
  let t83;
  if ($[158] !== t) {
    t83 = t("sections.calendar.mockup.days.6");
    $[158] = t;
    $[159] = t83;
  } else {
    t83 = $[159];
  }
  let t84;
  if ($[160] !== t83) {
    t84 = <div>{t83}</div>;
    $[160] = t83;
    $[161] = t84;
  } else {
    t84 = $[161];
  }
  let t85;
  if ($[162] !== t72 || $[163] !== t74 || $[164] !== t76 || $[165] !== t78 || $[166] !== t80 || $[167] !== t82 || $[168] !== t84) {
    t85 = <div className="mb-2 grid grid-cols-7 gap-2 text-center text-xs font-medium text-gray-400 uppercase">{t72}{t74}{t76}{t78}{t80}{t82}{t84}</div>;
    $[162] = t72;
    $[163] = t74;
    $[164] = t76;
    $[165] = t78;
    $[166] = t80;
    $[167] = t82;
    $[168] = t84;
    $[169] = t85;
  } else {
    t85 = $[169];
  }
  let t86;
  let t87;
  let t88;
  if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
    t86 = <div className="aspect-square p-1" />;
    t87 = <div className="aspect-square p-1" />;
    t88 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    $[170] = t86;
    $[171] = t87;
    $[172] = t88;
  } else {
    t86 = $[170];
    t87 = $[171];
    t88 = $[172];
  }
  let t89;
  if ($[173] !== t) {
    t89 = <div className="grid grid-cols-7 gap-2 text-sm">{t86}{t87}{t88.map(day => <div key={day} className={`flex aspect-square flex-col items-center rounded-lg border border-gray-100 p-1 dark:border-gray-800 ${day === 12 ? "border-blue-200 bg-blue-50 dark:border-blue-800 dark:bg-blue-900/20" : ""}`}><span className={`mb-1 text-xs ${day === 12 ? "font-bold text-blue-600 dark:text-blue-400" : "text-gray-700 dark:text-gray-300"}`}>{day}</span>{day === 12 && <div className="w-full truncate rounded bg-blue-100 px-1 py-0.5 text-[8px] font-medium text-blue-700 dark:bg-blue-900/50 dark:text-blue-300">{t("sections.calendar.mockup.event1.time")}{" "}{t("sections.calendar.mockup.event1.title")}</div>}{day === 15 && <div className="w-full truncate rounded bg-purple-100 px-1 py-0.5 text-[8px] font-medium text-purple-700 dark:bg-purple-900/50 dark:text-purple-300">{t("sections.calendar.mockup.event2.time")}{" "}{t("sections.calendar.mockup.event2.title")}</div>}</div>)}</div>;
    $[173] = t;
    $[174] = t89;
  } else {
    t89 = $[174];
  }
  let t90;
  if ($[175] !== t70 || $[176] !== t85 || $[177] !== t89) {
    t90 = <motion.div initial={t61} whileInView={t62} viewport={t63} transition={t64} className="relative order-2 lg:order-1">{t65}<div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t70}{t85}{t89}</div></motion.div>;
    $[175] = t70;
    $[176] = t85;
    $[177] = t89;
    $[178] = t90;
  } else {
    t90 = $[178];
  }
  let t91;
  if ($[179] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = {
      once: true
    };
    $[179] = t91;
  } else {
    t91 = $[179];
  }
  let t92;
  if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
    t92 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400"><Calendar className="h-6 w-6" /></div>;
    $[180] = t92;
  } else {
    t92 = $[180];
  }
  let t93;
  if ($[181] !== t) {
    t93 = t("sections.calendar.title");
    $[181] = t;
    $[182] = t93;
  } else {
    t93 = $[182];
  }
  let t94;
  if ($[183] !== t93) {
    t94 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t93}</h2>;
    $[183] = t93;
    $[184] = t94;
  } else {
    t94 = $[184];
  }
  let t95;
  if ($[185] !== t) {
    t95 = t("sections.calendar.description");
    $[185] = t;
    $[186] = t95;
  } else {
    t95 = $[186];
  }
  let t96;
  if ($[187] !== t95) {
    t96 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t95}</p>;
    $[187] = t95;
    $[188] = t96;
  } else {
    t96 = $[188];
  }
  let t97;
  if ($[189] !== t) {
    t97 = t("sections.calendar.items.0");
    $[189] = t;
    $[190] = t97;
  } else {
    t97 = $[190];
  }
  let t98;
  if ($[191] !== t) {
    t98 = t("sections.calendar.items.1");
    $[191] = t;
    $[192] = t98;
  } else {
    t98 = $[192];
  }
  let t99;
  if ($[193] !== t) {
    t99 = t("sections.calendar.items.2");
    $[193] = t;
    $[194] = t99;
  } else {
    t99 = $[194];
  }
  let t100;
  if ($[195] !== t97 || $[196] !== t98 || $[197] !== t99) {
    t100 = <ul className="space-y-4">{[t97, t98, t99].map(_temp4)}</ul>;
    $[195] = t97;
    $[196] = t98;
    $[197] = t99;
    $[198] = t100;
  } else {
    t100 = $[198];
  }
  let t101;
  if ($[199] !== t100 || $[200] !== t94 || $[201] !== t96) {
    t101 = <motion.div initial="hidden" whileInView="visible" viewport={t91} variants={fadeInUp} className="order-1 lg:order-2">{t92}{t94}{t96}{t100}</motion.div>;
    $[199] = t100;
    $[200] = t94;
    $[201] = t96;
    $[202] = t101;
  } else {
    t101 = $[202];
  }
  let t102;
  if ($[203] !== t101 || $[204] !== t90) {
    t102 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t90}{t101}</div></section>;
    $[203] = t101;
    $[204] = t90;
    $[205] = t102;
  } else {
    t102 = $[205];
  }
  let t103;
  if ($[206] === Symbol.for("react.memo_cache_sentinel")) {
    t103 = {
      once: true
    };
    $[206] = t103;
  } else {
    t103 = $[206];
  }
  let t104;
  if ($[207] === Symbol.for("react.memo_cache_sentinel")) {
    t104 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400"><Eye className="h-6 w-6" /></div>;
    $[207] = t104;
  } else {
    t104 = $[207];
  }
  let t105;
  if ($[208] !== t) {
    t105 = t("sections.visibility.title");
    $[208] = t;
    $[209] = t105;
  } else {
    t105 = $[209];
  }
  let t106;
  if ($[210] !== t105) {
    t106 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t105}</h2>;
    $[210] = t105;
    $[211] = t106;
  } else {
    t106 = $[211];
  }
  let t107;
  if ($[212] !== t) {
    t107 = t("sections.visibility.description");
    $[212] = t;
    $[213] = t107;
  } else {
    t107 = $[213];
  }
  let t108;
  if ($[214] !== t107) {
    t108 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t107}</p>;
    $[214] = t107;
    $[215] = t108;
  } else {
    t108 = $[215];
  }
  let t109;
  if ($[216] !== t) {
    t109 = t("sections.visibility.items.0");
    $[216] = t;
    $[217] = t109;
  } else {
    t109 = $[217];
  }
  let t110;
  if ($[218] !== t) {
    t110 = t("sections.visibility.items.1");
    $[218] = t;
    $[219] = t110;
  } else {
    t110 = $[219];
  }
  let t111;
  if ($[220] !== t) {
    t111 = t("sections.visibility.items.2");
    $[220] = t;
    $[221] = t111;
  } else {
    t111 = $[221];
  }
  let t112;
  if ($[222] !== t109 || $[223] !== t110 || $[224] !== t111) {
    t112 = <ul className="space-y-4">{[t109, t110, t111].map(_temp5)}</ul>;
    $[222] = t109;
    $[223] = t110;
    $[224] = t111;
    $[225] = t112;
  } else {
    t112 = $[225];
  }
  let t113;
  if ($[226] !== t106 || $[227] !== t108 || $[228] !== t112) {
    t113 = <motion.div initial="hidden" whileInView="visible" viewport={t103} variants={fadeInUp}>{t104}{t106}{t108}{t112}</motion.div>;
    $[226] = t106;
    $[227] = t108;
    $[228] = t112;
    $[229] = t113;
  } else {
    t113 = $[229];
  }
  let t114;
  let t115;
  let t116;
  let t117;
  if ($[230] === Symbol.for("react.memo_cache_sentinel")) {
    t114 = {
      opacity: 0,
      x: 40
    };
    t115 = {
      opacity: 1,
      x: 0
    };
    t116 = {
      once: true
    };
    t117 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[230] = t114;
    $[231] = t115;
    $[232] = t116;
    $[233] = t117;
  } else {
    t114 = $[230];
    t115 = $[231];
    t116 = $[232];
    t117 = $[233];
  }
  let t118;
  if ($[234] === Symbol.for("react.memo_cache_sentinel")) {
    t118 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-bl from-purple-500/10 to-pink-500/10 blur-3xl" />;
    $[234] = t118;
  } else {
    t118 = $[234];
  }
  let t119;
  if ($[235] === Symbol.for("react.memo_cache_sentinel")) {
    t119 = <div className="rounded-lg bg-green-100 p-2 text-green-600 dark:bg-green-900/30 dark:text-green-400"><Users className="h-5 w-5" /></div>;
    $[235] = t119;
  } else {
    t119 = $[235];
  }
  let t120;
  if ($[236] !== t) {
    t120 = t("sections.visibility.mockup.layer1.title");
    $[236] = t;
    $[237] = t120;
  } else {
    t120 = $[237];
  }
  let t121;
  if ($[238] !== t120) {
    t121 = <div className="font-semibold text-gray-900 dark:text-white">{t120}</div>;
    $[238] = t120;
    $[239] = t121;
  } else {
    t121 = $[239];
  }
  let t122;
  if ($[240] !== t) {
    t122 = t("sections.visibility.mockup.layer1.subtitle");
    $[240] = t;
    $[241] = t122;
  } else {
    t122 = $[241];
  }
  let t123;
  if ($[242] !== t122) {
    t123 = <div className="text-xs text-gray-500 dark:text-gray-400">{t122}</div>;
    $[242] = t122;
    $[243] = t123;
  } else {
    t123 = $[243];
  }
  let t124;
  if ($[244] !== t121 || $[245] !== t123) {
    t124 = <div className="flex items-center gap-3">{t119}<div>{t121}{t123}</div></div>;
    $[244] = t121;
    $[245] = t123;
    $[246] = t124;
  } else {
    t124 = $[246];
  }
  let t125;
  if ($[247] === Symbol.for("react.memo_cache_sentinel")) {
    t125 = <Eye className="h-4 w-4 text-gray-400" />;
    $[247] = t125;
  } else {
    t125 = $[247];
  }
  let t126;
  if ($[248] !== t124) {
    t126 = <div className="flex translate-x-4 scale-95 transform items-center justify-between rounded-xl border border-gray-200 bg-white p-4 opacity-60 shadow-lg dark:border-gray-800 dark:bg-gray-900">{t124}{t125}</div>;
    $[248] = t124;
    $[249] = t126;
  } else {
    t126 = $[249];
  }
  let t127;
  if ($[250] === Symbol.for("react.memo_cache_sentinel")) {
    t127 = <div className="rounded-lg bg-blue-100 p-2 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"><Building className="h-5 w-5" /></div>;
    $[250] = t127;
  } else {
    t127 = $[250];
  }
  let t128;
  if ($[251] !== t) {
    t128 = t("sections.visibility.mockup.layer2.title");
    $[251] = t;
    $[252] = t128;
  } else {
    t128 = $[252];
  }
  let t129;
  if ($[253] !== t128) {
    t129 = <div className="font-semibold text-gray-900 dark:text-white">{t128}</div>;
    $[253] = t128;
    $[254] = t129;
  } else {
    t129 = $[254];
  }
  let t130;
  if ($[255] !== t) {
    t130 = t("sections.visibility.mockup.layer2.subtitle");
    $[255] = t;
    $[256] = t130;
  } else {
    t130 = $[256];
  }
  let t131;
  if ($[257] !== t130) {
    t131 = <div className="text-xs text-gray-500 dark:text-gray-400">{t130}</div>;
    $[257] = t130;
    $[258] = t131;
  } else {
    t131 = $[258];
  }
  let t132;
  if ($[259] !== t129 || $[260] !== t131) {
    t132 = <div className="flex items-center gap-3">{t127}<div>{t129}{t131}</div></div>;
    $[259] = t129;
    $[260] = t131;
    $[261] = t132;
  } else {
    t132 = $[261];
  }
  let t133;
  if ($[262] === Symbol.for("react.memo_cache_sentinel")) {
    t133 = <Lock className="h-4 w-4 text-blue-500" />;
    $[262] = t133;
  } else {
    t133 = $[262];
  }
  let t134;
  if ($[263] !== t132) {
    t134 = <div className="z-10 flex translate-x-0 transform items-center justify-between rounded-xl border border-gray-200 bg-white p-4 shadow-lg dark:border-gray-800 dark:bg-gray-900">{t132}{t133}</div>;
    $[263] = t132;
    $[264] = t134;
  } else {
    t134 = $[264];
  }
  let t135;
  if ($[265] === Symbol.for("react.memo_cache_sentinel")) {
    t135 = <div className="rounded-lg bg-purple-100 p-2 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400"><Shield className="h-5 w-5" /></div>;
    $[265] = t135;
  } else {
    t135 = $[265];
  }
  let t136;
  if ($[266] !== t) {
    t136 = t("sections.visibility.mockup.layer3.title");
    $[266] = t;
    $[267] = t136;
  } else {
    t136 = $[267];
  }
  let t137;
  if ($[268] !== t136) {
    t137 = <div className="font-semibold text-gray-900 dark:text-white">{t136}</div>;
    $[268] = t136;
    $[269] = t137;
  } else {
    t137 = $[269];
  }
  let t138;
  if ($[270] !== t) {
    t138 = t("sections.visibility.mockup.layer3.subtitle");
    $[270] = t;
    $[271] = t138;
  } else {
    t138 = $[271];
  }
  let t139;
  if ($[272] !== t138) {
    t139 = <div className="text-xs text-gray-500 dark:text-gray-400">{t138}</div>;
    $[272] = t138;
    $[273] = t139;
  } else {
    t139 = $[273];
  }
  let t140;
  if ($[274] !== t137 || $[275] !== t139) {
    t140 = <div className="flex items-center gap-3">{t135}<div>{t137}{t139}</div></div>;
    $[274] = t137;
    $[275] = t139;
    $[276] = t140;
  } else {
    t140 = $[276];
  }
  let t141;
  if ($[277] === Symbol.for("react.memo_cache_sentinel")) {
    t141 = <Shield className="h-4 w-4 text-purple-500" />;
    $[277] = t141;
  } else {
    t141 = $[277];
  }
  let t142;
  if ($[278] !== t140) {
    t142 = <div className="flex translate-x-4 scale-95 transform items-center justify-between rounded-xl border border-gray-200 bg-white p-4 opacity-80 shadow-lg dark:border-gray-800 dark:bg-gray-900">{t140}{t141}</div>;
    $[278] = t140;
    $[279] = t142;
  } else {
    t142 = $[279];
  }
  let t143;
  if ($[280] !== t126 || $[281] !== t134 || $[282] !== t142) {
    t143 = <motion.div initial={t114} whileInView={t115} viewport={t116} transition={t117} className="relative">{t118}<div className="relative space-y-4">{t126}{t134}{t142}</div></motion.div>;
    $[280] = t126;
    $[281] = t134;
    $[282] = t142;
    $[283] = t143;
  } else {
    t143 = $[283];
  }
  let t144;
  if ($[284] !== t113 || $[285] !== t143) {
    t144 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t113}{t143}</div></section>;
    $[284] = t113;
    $[285] = t143;
    $[286] = t144;
  } else {
    t144 = $[286];
  }
  let t145;
  let t146;
  let t147;
  let t148;
  if ($[287] === Symbol.for("react.memo_cache_sentinel")) {
    t145 = {
      opacity: 0,
      x: -40
    };
    t146 = {
      opacity: 1,
      x: 0
    };
    t147 = {
      once: true
    };
    t148 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[287] = t145;
    $[288] = t146;
    $[289] = t147;
    $[290] = t148;
  } else {
    t145 = $[287];
    t146 = $[288];
    t147 = $[289];
    t148 = $[290];
  }
  let t149;
  if ($[291] === Symbol.for("react.memo_cache_sentinel")) {
    t149 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-teal-500/10 to-emerald-500/10 blur-3xl" />;
    $[291] = t149;
  } else {
    t149 = $[291];
  }
  let t150;
  if ($[292] !== t) {
    t150 = t("sections.ai.mockup.question");
    $[292] = t;
    $[293] = t150;
  } else {
    t150 = $[293];
  }
  let t151;
  if ($[294] !== t150) {
    t151 = <div className="flex justify-end"><div className="max-w-[80%] rounded-2xl rounded-tr-sm bg-gray-100 px-4 py-3 text-sm text-gray-900 dark:bg-gray-800 dark:text-white">{t150}</div></div>;
    $[294] = t150;
    $[295] = t151;
  } else {
    t151 = $[295];
  }
  let t152;
  if ($[296] === Symbol.for("react.memo_cache_sentinel")) {
    t152 = <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-teal-400 to-blue-500"><Sparkles className="h-4 w-4 text-white" /></div>;
    $[296] = t152;
  } else {
    t152 = $[296];
  }
  let t153;
  if ($[297] !== t) {
    t153 = t.rich("sections.ai.mockup.answer", {
      strong: _temp6
    });
    $[297] = t;
    $[298] = t153;
  } else {
    t153 = $[298];
  }
  let t154;
  if ($[299] !== t153) {
    t154 = <div className="rounded-2xl rounded-tl-sm border border-teal-100 bg-teal-50 px-4 py-3 text-sm leading-relaxed text-gray-800 dark:border-teal-900/50 dark:bg-teal-900/20 dark:text-gray-200">{t153}</div>;
    $[299] = t153;
    $[300] = t154;
  } else {
    t154 = $[300];
  }
  let t155;
  if ($[301] === Symbol.for("react.memo_cache_sentinel")) {
    t155 = <FileText className="h-3 w-3" />;
    $[301] = t155;
  } else {
    t155 = $[301];
  }
  let t156;
  if ($[302] !== t) {
    t156 = t("sections.ai.mockup.source");
    $[302] = t;
    $[303] = t156;
  } else {
    t156 = $[303];
  }
  let t157;
  if ($[304] !== t156) {
    t157 = <div className="flex items-center gap-2 pl-1 text-xs text-gray-500 dark:text-gray-400">{t155}{t156}</div>;
    $[304] = t156;
    $[305] = t157;
  } else {
    t157 = $[305];
  }
  let t158;
  if ($[306] !== t154 || $[307] !== t157) {
    t158 = <div className="flex gap-4">{t152}<div className="max-w-[90%] space-y-2">{t154}{t157}</div></div>;
    $[306] = t154;
    $[307] = t157;
    $[308] = t158;
  } else {
    t158 = $[308];
  }
  let t159;
  if ($[309] !== t151 || $[310] !== t158) {
    t159 = <div className="space-y-6">{t151}{t158}</div>;
    $[309] = t151;
    $[310] = t158;
    $[311] = t159;
  } else {
    t159 = $[311];
  }
  let t160;
  if ($[312] !== t) {
    t160 = t("sections.ai.mockup.input_placeholder");
    $[312] = t;
    $[313] = t160;
  } else {
    t160 = $[313];
  }
  let t161;
  if ($[314] !== t160) {
    t161 = <div className="flex h-12 items-center rounded-xl border border-gray-200 bg-white px-4 text-sm text-gray-400 dark:border-gray-800 dark:bg-gray-950">{t160}</div>;
    $[314] = t160;
    $[315] = t161;
  } else {
    t161 = $[315];
  }
  let t162;
  if ($[316] === Symbol.for("react.memo_cache_sentinel")) {
    t162 = <div className="absolute top-2 right-2 rounded-lg bg-teal-600 p-2 text-white"><ArrowRight className="h-4 w-4" /></div>;
    $[316] = t162;
  } else {
    t162 = $[316];
  }
  let t163;
  if ($[317] !== t161) {
    t163 = <div className="relative mt-6">{t161}{t162}</div>;
    $[317] = t161;
    $[318] = t163;
  } else {
    t163 = $[318];
  }
  let t164;
  if ($[319] !== t159 || $[320] !== t163) {
    t164 = <motion.div initial={t145} whileInView={t146} viewport={t147} transition={t148} className="relative order-2 lg:order-1">{t149}<div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t159}{t163}</div></motion.div>;
    $[319] = t159;
    $[320] = t163;
    $[321] = t164;
  } else {
    t164 = $[321];
  }
  let t165;
  if ($[322] === Symbol.for("react.memo_cache_sentinel")) {
    t165 = {
      once: true
    };
    $[322] = t165;
  } else {
    t165 = $[322];
  }
  let t166;
  if ($[323] === Symbol.for("react.memo_cache_sentinel")) {
    t166 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-100 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400"><Sparkles className="h-6 w-6" /></div>;
    $[323] = t166;
  } else {
    t166 = $[323];
  }
  let t167;
  if ($[324] !== t) {
    t167 = t("sections.ai.title");
    $[324] = t;
    $[325] = t167;
  } else {
    t167 = $[325];
  }
  let t168;
  if ($[326] !== t167) {
    t168 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t167}</h2>;
    $[326] = t167;
    $[327] = t168;
  } else {
    t168 = $[327];
  }
  let t169;
  if ($[328] !== t) {
    t169 = t("sections.ai.description");
    $[328] = t;
    $[329] = t169;
  } else {
    t169 = $[329];
  }
  let t170;
  if ($[330] !== t169) {
    t170 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t169}</p>;
    $[330] = t169;
    $[331] = t170;
  } else {
    t170 = $[331];
  }
  let t171;
  if ($[332] !== t) {
    t171 = t("sections.ai.items.0");
    $[332] = t;
    $[333] = t171;
  } else {
    t171 = $[333];
  }
  let t172;
  if ($[334] !== t) {
    t172 = t("sections.ai.items.1");
    $[334] = t;
    $[335] = t172;
  } else {
    t172 = $[335];
  }
  let t173;
  if ($[336] !== t) {
    t173 = t("sections.ai.items.2");
    $[336] = t;
    $[337] = t173;
  } else {
    t173 = $[337];
  }
  let t174;
  if ($[338] !== t171 || $[339] !== t172 || $[340] !== t173) {
    t174 = <ul className="space-y-4">{[t171, t172, t173].map(_temp7)}</ul>;
    $[338] = t171;
    $[339] = t172;
    $[340] = t173;
    $[341] = t174;
  } else {
    t174 = $[341];
  }
  let t175;
  if ($[342] !== t168 || $[343] !== t170 || $[344] !== t174) {
    t175 = <motion.div initial="hidden" whileInView="visible" viewport={t165} variants={fadeInUp} className="order-1 lg:order-2">{t166}{t168}{t170}{t174}</motion.div>;
    $[342] = t168;
    $[343] = t170;
    $[344] = t174;
    $[345] = t175;
  } else {
    t175 = $[345];
  }
  let t176;
  if ($[346] !== t164 || $[347] !== t175) {
    t176 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t164}{t175}</div></section>;
    $[346] = t164;
    $[347] = t175;
    $[348] = t176;
  } else {
    t176 = $[348];
  }
  let t177;
  if ($[349] === Symbol.for("react.memo_cache_sentinel")) {
    t177 = {
      once: true
    };
    $[349] = t177;
  } else {
    t177 = $[349];
  }
  let t178;
  if ($[350] === Symbol.for("react.memo_cache_sentinel")) {
    t178 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400"><FolderOpen className="h-6 w-6" /></div>;
    $[350] = t178;
  } else {
    t178 = $[350];
  }
  let t179;
  if ($[351] !== t) {
    t179 = t("sections.documents.title");
    $[351] = t;
    $[352] = t179;
  } else {
    t179 = $[352];
  }
  let t180;
  if ($[353] !== t179) {
    t180 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t179}</h2>;
    $[353] = t179;
    $[354] = t180;
  } else {
    t180 = $[354];
  }
  let t181;
  if ($[355] !== t) {
    t181 = t("sections.documents.description");
    $[355] = t;
    $[356] = t181;
  } else {
    t181 = $[356];
  }
  let t182;
  if ($[357] !== t181) {
    t182 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t181}</p>;
    $[357] = t181;
    $[358] = t182;
  } else {
    t182 = $[358];
  }
  let t183;
  if ($[359] !== t) {
    t183 = t("sections.documents.items.0");
    $[359] = t;
    $[360] = t183;
  } else {
    t183 = $[360];
  }
  let t184;
  if ($[361] !== t) {
    t184 = t("sections.documents.items.1");
    $[361] = t;
    $[362] = t184;
  } else {
    t184 = $[362];
  }
  let t185;
  if ($[363] !== t) {
    t185 = t("sections.documents.items.2");
    $[363] = t;
    $[364] = t185;
  } else {
    t185 = $[364];
  }
  let t186;
  if ($[365] !== t183 || $[366] !== t184 || $[367] !== t185) {
    t186 = <ul className="space-y-4">{[t183, t184, t185].map(_temp8)}</ul>;
    $[365] = t183;
    $[366] = t184;
    $[367] = t185;
    $[368] = t186;
  } else {
    t186 = $[368];
  }
  let t187;
  if ($[369] !== t180 || $[370] !== t182 || $[371] !== t186) {
    t187 = <motion.div initial="hidden" whileInView="visible" viewport={t177} variants={fadeInUp}>{t178}{t180}{t182}{t186}</motion.div>;
    $[369] = t180;
    $[370] = t182;
    $[371] = t186;
    $[372] = t187;
  } else {
    t187 = $[372];
  }
  let t188;
  let t189;
  let t190;
  let t191;
  if ($[373] === Symbol.for("react.memo_cache_sentinel")) {
    t188 = {
      opacity: 0,
      x: 40
    };
    t189 = {
      opacity: 1,
      x: 0
    };
    t190 = {
      once: true
    };
    t191 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[373] = t188;
    $[374] = t189;
    $[375] = t190;
    $[376] = t191;
  } else {
    t188 = $[373];
    t189 = $[374];
    t190 = $[375];
    t191 = $[376];
  }
  let t192;
  if ($[377] === Symbol.for("react.memo_cache_sentinel")) {
    t192 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-bl from-orange-500/10 to-amber-500/10 blur-3xl" />;
    $[377] = t192;
  } else {
    t192 = $[377];
  }
  let t193;
  if ($[378] === Symbol.for("react.memo_cache_sentinel")) {
    t193 = <div className="flex items-center gap-3 border-b border-gray-100 p-4 dark:border-gray-800"><Search className="h-4 w-4 text-gray-400" /><div className="h-2 w-24 rounded-full bg-gray-100 dark:bg-gray-800" /></div>;
    $[378] = t193;
  } else {
    t193 = $[378];
  }
  let t194;
  if ($[379] !== t) {
    t194 = t("sections.documents.mockup.doc1.name");
    $[379] = t;
    $[380] = t194;
  } else {
    t194 = $[380];
  }
  let t195;
  if ($[381] !== t) {
    t195 = t("sections.documents.mockup.doc1.date");
    $[381] = t;
    $[382] = t195;
  } else {
    t195 = $[382];
  }
  let t196;
  if ($[383] !== t194 || $[384] !== t195) {
    t196 = {
      name: t194,
      date: t195,
      type: "pdf",
      color: "text-red-500"
    };
    $[383] = t194;
    $[384] = t195;
    $[385] = t196;
  } else {
    t196 = $[385];
  }
  let t197;
  if ($[386] !== t) {
    t197 = t("sections.documents.mockup.doc2.name");
    $[386] = t;
    $[387] = t197;
  } else {
    t197 = $[387];
  }
  let t198;
  if ($[388] !== t) {
    t198 = t("sections.documents.mockup.doc2.date");
    $[388] = t;
    $[389] = t198;
  } else {
    t198 = $[389];
  }
  let t199;
  if ($[390] !== t197 || $[391] !== t198) {
    t199 = {
      name: t197,
      date: t198,
      type: "pdf",
      color: "text-red-500"
    };
    $[390] = t197;
    $[391] = t198;
    $[392] = t199;
  } else {
    t199 = $[392];
  }
  let t200;
  if ($[393] !== t) {
    t200 = t("sections.documents.mockup.doc3.name");
    $[393] = t;
    $[394] = t200;
  } else {
    t200 = $[394];
  }
  let t201;
  if ($[395] !== t) {
    t201 = t("sections.documents.mockup.doc3.date");
    $[395] = t;
    $[396] = t201;
  } else {
    t201 = $[396];
  }
  let t202;
  if ($[397] !== t200 || $[398] !== t201) {
    t202 = {
      name: t200,
      date: t201,
      type: "pdf",
      color: "text-red-500"
    };
    $[397] = t200;
    $[398] = t201;
    $[399] = t202;
  } else {
    t202 = $[399];
  }
  let t203;
  if ($[400] !== t) {
    t203 = t("sections.documents.mockup.doc4.name");
    $[400] = t;
    $[401] = t203;
  } else {
    t203 = $[401];
  }
  let t204;
  if ($[402] !== t) {
    t204 = t("sections.documents.mockup.doc4.date");
    $[402] = t;
    $[403] = t204;
  } else {
    t204 = $[403];
  }
  let t205;
  if ($[404] !== t203 || $[405] !== t204) {
    t205 = {
      name: t203,
      date: t204,
      type: "img",
      color: "text-blue-500"
    };
    $[404] = t203;
    $[405] = t204;
    $[406] = t205;
  } else {
    t205 = $[406];
  }
  let t206;
  if ($[407] !== t196 || $[408] !== t199 || $[409] !== t202 || $[410] !== t205) {
    t206 = <motion.div initial={t188} whileInView={t189} viewport={t190} transition={t191} className="relative">{t192}<div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t193}<div className="p-2">{[t196, t199, t202, t205].map(_temp9)}</div></div></motion.div>;
    $[407] = t196;
    $[408] = t199;
    $[409] = t202;
    $[410] = t205;
    $[411] = t206;
  } else {
    t206 = $[411];
  }
  let t207;
  if ($[412] !== t187 || $[413] !== t206) {
    t207 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t187}{t206}</div></section>;
    $[412] = t187;
    $[413] = t206;
    $[414] = t207;
  } else {
    t207 = $[414];
  }
  let t208;
  let t209;
  let t210;
  let t211;
  if ($[415] === Symbol.for("react.memo_cache_sentinel")) {
    t208 = {
      opacity: 0,
      x: -40
    };
    t209 = {
      opacity: 1,
      x: 0
    };
    t210 = {
      once: true
    };
    t211 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[415] = t208;
    $[416] = t209;
    $[417] = t210;
    $[418] = t211;
  } else {
    t208 = $[415];
    t209 = $[416];
    t210 = $[417];
    t211 = $[418];
  }
  let t212;
  if ($[419] === Symbol.for("react.memo_cache_sentinel")) {
    t212 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-pink-500/10 to-rose-500/10 blur-3xl" />;
    $[419] = t212;
  } else {
    t212 = $[419];
  }
  let t213;
  if ($[420] === Symbol.for("react.memo_cache_sentinel")) {
    t213 = <BarChart3 className="h-4 w-4 text-pink-500" />;
    $[420] = t213;
  } else {
    t213 = $[420];
  }
  let t214;
  if ($[421] !== t) {
    t214 = t("sections.smartCommunication.mockup.pollQuestion");
    $[421] = t;
    $[422] = t214;
  } else {
    t214 = $[422];
  }
  let t215;
  if ($[423] !== t214) {
    t215 = <div className="mb-4 flex items-center gap-2">{t213}<span className="text-sm font-medium text-gray-700 dark:text-gray-300">{t214}</span></div>;
    $[423] = t214;
    $[424] = t215;
  } else {
    t215 = $[424];
  }
  let t216;
  if ($[425] !== t) {
    t216 = t("sections.smartCommunication.mockup.option1");
    $[425] = t;
    $[426] = t216;
  } else {
    t216 = $[426];
  }
  let t217;
  if ($[427] !== t) {
    t217 = t("sections.smartCommunication.mockup.option2");
    $[427] = t;
    $[428] = t217;
  } else {
    t217 = $[428];
  }
  let t218;
  if ($[429] !== t) {
    t218 = t("sections.smartCommunication.mockup.option3");
    $[429] = t;
    $[430] = t218;
  } else {
    t218 = $[430];
  }
  let t219;
  if ($[431] !== t216 || $[432] !== t217 || $[433] !== t218) {
    t219 = <div className="space-y-2">{[t216, t217, t218].map(_temp10)}</div>;
    $[431] = t216;
    $[432] = t217;
    $[433] = t218;
    $[434] = t219;
  } else {
    t219 = $[434];
  }
  let t220;
  if ($[435] !== t215 || $[436] !== t219) {
    t220 = <div className="mb-6 rounded-xl border border-gray-100 bg-gray-50 p-4 dark:border-gray-800 dark:bg-gray-950/50">{t215}{t219}</div>;
    $[435] = t215;
    $[436] = t219;
    $[437] = t220;
  } else {
    t220 = $[437];
  }
  let t221;
  if ($[438] === Symbol.for("react.memo_cache_sentinel")) {
    t221 = <Sparkles className="h-4 w-4 text-teal-600 dark:text-teal-400" />;
    $[438] = t221;
  } else {
    t221 = $[438];
  }
  let t222;
  if ($[439] !== t) {
    t222 = t("sections.smartCommunication.mockup.aiSummaryTitle");
    $[439] = t;
    $[440] = t222;
  } else {
    t222 = $[440];
  }
  let t223;
  if ($[441] !== t222) {
    t223 = <div className="mb-3 flex items-center gap-2">{t221}<span className="text-sm font-medium text-teal-700 dark:text-teal-400">{t222}</span></div>;
    $[441] = t222;
    $[442] = t223;
  } else {
    t223 = $[442];
  }
  let t224;
  if ($[443] === Symbol.for("react.memo_cache_sentinel")) {
    t224 = <div className="space-y-2"><div className="h-2 w-full rounded-full bg-teal-200/50 dark:bg-teal-800/50" /><div className="h-2 w-4/5 rounded-full bg-teal-200/50 dark:bg-teal-800/50" /><div className="h-2 w-3/5 rounded-full bg-teal-200/50 dark:bg-teal-800/50" /></div>;
    $[443] = t224;
  } else {
    t224 = $[443];
  }
  let t225;
  if ($[444] !== t223) {
    t225 = <div className="rounded-xl border border-teal-100 bg-teal-50/50 p-4 dark:border-teal-900/30 dark:bg-teal-900/20">{t223}{t224}</div>;
    $[444] = t223;
    $[445] = t225;
  } else {
    t225 = $[445];
  }
  let t226;
  if ($[446] !== t220 || $[447] !== t225) {
    t226 = <motion.div initial={t208} whileInView={t209} viewport={t210} transition={t211} className="relative order-2 lg:order-1">{t212}<div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t220}{t225}</div></motion.div>;
    $[446] = t220;
    $[447] = t225;
    $[448] = t226;
  } else {
    t226 = $[448];
  }
  let t227;
  if ($[449] === Symbol.for("react.memo_cache_sentinel")) {
    t227 = {
      once: true
    };
    $[449] = t227;
  } else {
    t227 = $[449];
  }
  let t228;
  if ($[450] === Symbol.for("react.memo_cache_sentinel")) {
    t228 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-pink-100 text-pink-600 dark:bg-pink-900/30 dark:text-pink-400"><Megaphone className="h-6 w-6" /></div>;
    $[450] = t228;
  } else {
    t228 = $[450];
  }
  let t229;
  if ($[451] !== t) {
    t229 = t("sections.smartCommunication.title");
    $[451] = t;
    $[452] = t229;
  } else {
    t229 = $[452];
  }
  let t230;
  if ($[453] !== t229) {
    t230 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t229}</h2>;
    $[453] = t229;
    $[454] = t230;
  } else {
    t230 = $[454];
  }
  let t231;
  if ($[455] !== t) {
    t231 = t("sections.smartCommunication.description");
    $[455] = t;
    $[456] = t231;
  } else {
    t231 = $[456];
  }
  let t232;
  if ($[457] !== t231) {
    t232 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t231}</p>;
    $[457] = t231;
    $[458] = t232;
  } else {
    t232 = $[458];
  }
  let t233;
  if ($[459] !== t) {
    t233 = t("sections.smartCommunication.items.0");
    $[459] = t;
    $[460] = t233;
  } else {
    t233 = $[460];
  }
  let t234;
  if ($[461] !== t) {
    t234 = t("sections.smartCommunication.items.1");
    $[461] = t;
    $[462] = t234;
  } else {
    t234 = $[462];
  }
  let t235;
  if ($[463] !== t) {
    t235 = t("sections.smartCommunication.items.2");
    $[463] = t;
    $[464] = t235;
  } else {
    t235 = $[464];
  }
  let t236;
  if ($[465] !== t233 || $[466] !== t234 || $[467] !== t235) {
    t236 = <ul className="space-y-4">{[t233, t234, t235].map(_temp11)}</ul>;
    $[465] = t233;
    $[466] = t234;
    $[467] = t235;
    $[468] = t236;
  } else {
    t236 = $[468];
  }
  let t237;
  if ($[469] !== t230 || $[470] !== t232 || $[471] !== t236) {
    t237 = <motion.div initial="hidden" whileInView="visible" viewport={t227} variants={fadeInUp} className="order-1 lg:order-2">{t228}{t230}{t232}{t236}</motion.div>;
    $[469] = t230;
    $[470] = t232;
    $[471] = t236;
    $[472] = t237;
  } else {
    t237 = $[472];
  }
  let t238;
  if ($[473] !== t226 || $[474] !== t237) {
    t238 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t226}{t237}</div></section>;
    $[473] = t226;
    $[474] = t237;
    $[475] = t238;
  } else {
    t238 = $[475];
  }
  let t239;
  if ($[476] === Symbol.for("react.memo_cache_sentinel")) {
    t239 = {
      once: true
    };
    $[476] = t239;
  } else {
    t239 = $[476];
  }
  let t240;
  if ($[477] === Symbol.for("react.memo_cache_sentinel")) {
    t240 = <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-100 text-cyan-600 dark:bg-cyan-900/30 dark:text-cyan-400"><Users className="h-6 w-6" /></div>;
    $[477] = t240;
  } else {
    t240 = $[477];
  }
  let t241;
  if ($[478] !== t) {
    t241 = t("sections.guestAccess.title");
    $[478] = t;
    $[479] = t241;
  } else {
    t241 = $[479];
  }
  let t242;
  if ($[480] !== t241) {
    t242 = <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">{t241}</h2>;
    $[480] = t241;
    $[481] = t242;
  } else {
    t242 = $[481];
  }
  let t243;
  if ($[482] !== t) {
    t243 = t("sections.guestAccess.description");
    $[482] = t;
    $[483] = t243;
  } else {
    t243 = $[483];
  }
  let t244;
  if ($[484] !== t243) {
    t244 = <p className="mb-8 text-lg leading-relaxed text-gray-600 dark:text-gray-300">{t243}</p>;
    $[484] = t243;
    $[485] = t244;
  } else {
    t244 = $[485];
  }
  let t245;
  if ($[486] !== t) {
    t245 = t("sections.guestAccess.items.0");
    $[486] = t;
    $[487] = t245;
  } else {
    t245 = $[487];
  }
  let t246;
  if ($[488] !== t) {
    t246 = t("sections.guestAccess.items.1");
    $[488] = t;
    $[489] = t246;
  } else {
    t246 = $[489];
  }
  let t247;
  if ($[490] !== t) {
    t247 = t("sections.guestAccess.items.2");
    $[490] = t;
    $[491] = t247;
  } else {
    t247 = $[491];
  }
  let t248;
  if ($[492] !== t245 || $[493] !== t246 || $[494] !== t247) {
    t248 = <ul className="space-y-4">{[t245, t246, t247].map(_temp12)}</ul>;
    $[492] = t245;
    $[493] = t246;
    $[494] = t247;
    $[495] = t248;
  } else {
    t248 = $[495];
  }
  let t249;
  if ($[496] !== t242 || $[497] !== t244 || $[498] !== t248) {
    t249 = <motion.div initial="hidden" whileInView="visible" viewport={t239} variants={fadeInUp}>{t240}{t242}{t244}{t248}</motion.div>;
    $[496] = t242;
    $[497] = t244;
    $[498] = t248;
    $[499] = t249;
  } else {
    t249 = $[499];
  }
  let t250;
  let t251;
  let t252;
  let t253;
  if ($[500] === Symbol.for("react.memo_cache_sentinel")) {
    t250 = {
      opacity: 0,
      x: 40
    };
    t251 = {
      opacity: 1,
      x: 0
    };
    t252 = {
      once: true
    };
    t253 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[500] = t250;
    $[501] = t251;
    $[502] = t252;
    $[503] = t253;
  } else {
    t250 = $[500];
    t251 = $[501];
    t252 = $[502];
    t253 = $[503];
  }
  let t254;
  if ($[504] === Symbol.for("react.memo_cache_sentinel")) {
    t254 = <div className="absolute inset-0 rounded-3xl bg-gradient-to-bl from-cyan-500/10 to-blue-500/10 blur-3xl" />;
    $[504] = t254;
  } else {
    t254 = $[504];
  }
  let t255;
  if ($[505] === Symbol.for("react.memo_cache_sentinel")) {
    t255 = <Shield className="h-4 w-4 text-cyan-600 dark:text-cyan-400" />;
    $[505] = t255;
  } else {
    t255 = $[505];
  }
  let t256;
  if ($[506] !== t) {
    t256 = t("sections.guestAccess.mockup.cardTitle");
    $[506] = t;
    $[507] = t256;
  } else {
    t256 = $[507];
  }
  let t257;
  if ($[508] !== t256) {
    t257 = <div className="mb-3 flex items-center gap-2">{t255}<span className="text-sm font-semibold text-cyan-700 dark:text-cyan-400">{t256}</span></div>;
    $[508] = t256;
    $[509] = t257;
  } else {
    t257 = $[509];
  }
  let t258;
  if ($[510] !== t) {
    t258 = t("sections.guestAccess.mockup.linkPreview");
    $[510] = t;
    $[511] = t258;
  } else {
    t258 = $[511];
  }
  let t259;
  if ($[512] !== t258) {
    t259 = <div className="mb-3 rounded-lg bg-white p-2 text-xs text-gray-500 dark:bg-gray-800 dark:text-gray-400">{t258}</div>;
    $[512] = t258;
    $[513] = t259;
  } else {
    t259 = $[513];
  }
  let t260;
  if ($[514] !== t) {
    t260 = t("sections.guestAccess.mockup.copyButton");
    $[514] = t;
    $[515] = t260;
  } else {
    t260 = $[515];
  }
  let t261;
  if ($[516] !== t260) {
    t261 = <div className="flex h-8 flex-1 items-center justify-center rounded-lg bg-cyan-600 text-xs font-medium text-white">{t260}</div>;
    $[516] = t260;
    $[517] = t261;
  } else {
    t261 = $[517];
  }
  let t262;
  if ($[518] === Symbol.for("react.memo_cache_sentinel")) {
    t262 = <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-cyan-200 text-cyan-600 dark:border-cyan-800 dark:text-cyan-400"><ArrowRight className="h-4 w-4" /></div>;
    $[518] = t262;
  } else {
    t262 = $[518];
  }
  let t263;
  if ($[519] !== t261) {
    t263 = <div className="flex gap-2">{t261}{t262}</div>;
    $[519] = t261;
    $[520] = t263;
  } else {
    t263 = $[520];
  }
  let t264;
  if ($[521] !== t257 || $[522] !== t259 || $[523] !== t263) {
    t264 = <div className="mb-4 rounded-xl border border-dashed border-cyan-300 bg-cyan-50/50 p-4 dark:border-cyan-800 dark:bg-cyan-900/20">{t257}{t259}{t263}</div>;
    $[521] = t257;
    $[522] = t259;
    $[523] = t263;
    $[524] = t264;
  } else {
    t264 = $[524];
  }
  let t265;
  if ($[525] !== t) {
    t265 = t("sections.guestAccess.mockup.subscribersTitle");
    $[525] = t;
    $[526] = t265;
  } else {
    t265 = $[526];
  }
  let t266;
  if ($[527] !== t265) {
    t266 = <div className="text-xs font-medium text-gray-500 dark:text-gray-400">{t265}</div>;
    $[527] = t265;
    $[528] = t266;
  } else {
    t266 = $[528];
  }
  let t267;
  if ($[529] !== t) {
    t267 = [t("sections.guestAccess.mockup.subscriber1"), t("sections.guestAccess.mockup.subscriber2")].map((name, i_8) => <div key={i_8} className="flex items-center justify-between rounded-lg border border-gray-100 bg-gray-50 p-3 dark:border-gray-800 dark:bg-gray-950/50"><div className="flex items-center gap-3"><div className="flex h-8 w-8 items-center justify-center rounded-full bg-cyan-100 text-xs font-bold text-cyan-600 dark:bg-cyan-900 dark:text-cyan-400">{name.charAt(0)}</div><span className="text-sm text-gray-700 dark:text-gray-300">{name}</span></div><span className="rounded-full bg-green-100 px-2 py-0.5 text-xs text-green-700 dark:bg-green-900/30 dark:text-green-400">{t("sections.guestAccess.mockup.verifiedBadge")}</span></div>);
    $[529] = t;
    $[530] = t267;
  } else {
    t267 = $[530];
  }
  let t268;
  if ($[531] !== t266 || $[532] !== t267) {
    t268 = <div className="space-y-3">{t266}{t267}</div>;
    $[531] = t266;
    $[532] = t267;
    $[533] = t268;
  } else {
    t268 = $[533];
  }
  let t269;
  if ($[534] !== t264 || $[535] !== t268) {
    t269 = <motion.div initial={t250} whileInView={t251} viewport={t252} transition={t253} className="relative">{t254}<div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-800 dark:bg-gray-900">{t264}{t268}</div></motion.div>;
    $[534] = t264;
    $[535] = t268;
    $[536] = t269;
  } else {
    t269 = $[536];
  }
  let t270;
  if ($[537] !== t249 || $[538] !== t269) {
    t270 = <section className="container mx-auto mb-32 px-4"><div className="grid items-center gap-16 lg:grid-cols-2">{t249}{t269}</div></section>;
    $[537] = t249;
    $[538] = t269;
    $[539] = t270;
  } else {
    t270 = $[539];
  }
  let t271;
  if ($[540] !== t) {
    t271 = isPricingEnabledClient() ? <section className="container mx-auto px-4 py-12 text-center"><div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 to-gray-800 p-12"><div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10" /><div className="relative z-10 mx-auto max-w-2xl"><h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">{t("cta.title")}</h2><p className="mb-8 text-lg text-gray-300">{t.rich("cta.description", {
              br: _temp13,
              highlight: _temp14
            })}</p><div className="flex flex-col justify-center gap-4 sm:flex-row"><Link href="/auth/signup"><Button size="lg" className="h-12 w-full bg-teal-600 px-8 text-base text-white hover:bg-teal-700 sm:w-auto">{t("cta.start")}</Button></Link></div></div></div></section> : <section className="container mx-auto px-4 py-12 text-center"><div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 to-gray-800 p-12"><div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10" /><div className="relative z-10 mx-auto max-w-2xl"><h2 className="mb-6 text-3xl font-bold text-white md:text-4xl">{t("cta.waitlist_title") || "Join the Waitlist"}</h2><p className="mb-8 text-lg text-gray-300">{t("cta.waitlist_description") || "Sign up to be notified when we launch."}</p><div className="flex flex-col justify-center gap-4 sm:flex-row"><Link href="/waitlist"><Button size="lg" className="h-12 w-full bg-teal-600 px-8 text-base text-white hover:bg-teal-700 sm:w-auto">{t("cta.join_waitlist") || "Join Waitlist"}</Button></Link></div></div></div></section>;
    $[540] = t;
    $[541] = t271;
  } else {
    t271 = $[541];
  }
  let t272;
  if ($[542] !== t10 || $[543] !== t102 || $[544] !== t144 || $[545] !== t176 || $[546] !== t207 || $[547] !== t238 || $[548] !== t270 || $[549] !== t271 || $[550] !== t60) {
    t272 = <div className="pt-32 pb-24">{t10}{t60}{t102}{t144}{t176}{t207}{t238}{t270}{t271}</div>;
    $[542] = t10;
    $[543] = t102;
    $[544] = t144;
    $[545] = t176;
    $[546] = t207;
    $[547] = t238;
    $[548] = t270;
    $[549] = t271;
    $[550] = t60;
    $[551] = t272;
  } else {
    t272 = $[551];
  }
  return t272;
}
function _temp14(chunks_1) {
  return <span className="font-semibold text-teal-400">{chunks_1}</span>;
}
function _temp13() {
  return <br />;
}
function _temp12(item_5, i_7) {
  return <li key={i_7} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cyan-100 dark:bg-cyan-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-cyan-600 dark:text-cyan-400" /></div>{item_5}</li>;
}
function _temp11(item_4, i_6) {
  return <li key={i_6} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-pink-100 dark:bg-pink-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-pink-600 dark:text-pink-400" /></div>{item_4}</li>;
}
function _temp10(option, i_5) {
  return <div key={i_5} className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-800"><div className="h-4 w-4 rounded-full border-2 border-gray-300 dark:border-gray-600" /><span className="text-sm text-gray-700 dark:text-gray-300">{option}</span></div>;
}
function _temp9(doc, i_4) {
  return <div key={i_4} className="group flex cursor-pointer items-center justify-between rounded-lg p-3 transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/50"><div className="flex items-center gap-3"><div className={`rounded-lg bg-gray-100 p-2 dark:bg-gray-800 ${doc.color}`}><FileText className="h-5 w-5" /></div><div><div className="text-sm font-medium text-gray-900 transition-colors group-hover:text-teal-600 dark:text-white">{doc.name}</div><div className="text-xs text-gray-500 dark:text-gray-400">{doc.date}</div></div></div><div className="text-gray-400 opacity-0 transition-opacity group-hover:opacity-100"><ArrowRight className="h-4 w-4" /></div></div>;
}
function _temp8(item_3, i_3) {
  return <li key={i_3} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-amber-600 dark:text-amber-400" /></div>{item_3}</li>;
}
function _temp7(item_2, i_2) {
  return <li key={i_2} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-100 dark:bg-teal-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-teal-600 dark:text-teal-400" /></div>{item_2}</li>;
}
function _temp6(chunks_0) {
  return <strong>{chunks_0}</strong>;
}
function _temp5(item_1, i_1) {
  return <li key={i_1} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-purple-600 dark:text-purple-400" /></div>{item_1}</li>;
}
function _temp4(item_0, i_0) {
  return <li key={i_0} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-indigo-100 dark:bg-indigo-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-indigo-600 dark:text-indigo-400" /></div>{item_0}</li>;
}
function _temp3(item, i) {
  return <li key={i} className="flex items-center gap-3 text-gray-700 dark:text-gray-300"><div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30"><CheckCircle2 className="h-3.5 w-3.5 text-green-600 dark:text-green-400" /></div>{item}</li>;
}
function _temp2(chunks) {
  return <span className="bg-brand-text-gradient animate-gradient-x bg-[length:200%_auto] bg-clip-text text-transparent">{chunks}</span>;
}
function _temp() {
  return <br />;
}